export default __webpack_public_path__ + "static/media/chair.2ca48dda.ogg";